import React, { useEffect, useState, useContext } from 'react';
import { ConfigContext } from '../../DynamicForm/DynamicForm';
import Required from "../../../../components/Required";
import Checkbox from "../../../../components/Checkbox";
import { Field } from "formik";
import RadioButtonGroup from "../../../../components/RadioButtonGroup";
import RadioButton from "../../../../components/RadioButton";
import Facilities_7224 from '../../orgs/7224/facilities';
import Facilities_7168 from '../../orgs/7168/facilities';
import Facilities_7302 from '../../orgs/7302/facilities';
import FacilitiesSelectionList from './RenderFacilitiesSelectionList';
import FacilityAdvancedList from './RenderFacilityAdvancedList';
import FacilityRadioList from './RenderFacilityRadioList';
import NYPOutpatientFacilities from '../../orgs/7042/facilities';
import TripartiteFacilities from '../../orgs/7042/facilities_patient';
import { DisabledCheckbox } from '../../orgs/7042/components';
import Facilities_7227 from '../../orgs/7227/facilities';
import Facilities_NameAddressDoc from '../../../../components/FacilitySections/NameAddressDoc/NameAddressDoc';
import { SectionHeader } from '../../../../components/sectionHeader/sectionHeader';
import { AuthCheckbox } from '../../../../components/unused/authCheckbox';
import CheckField from '../../../../components/CheckField2/CheckField';
import CustomInput, { AddButton, CustomInputSystem } from '../../../../components/CustomInput/CustomInput';
import ChipSet from '../../../../components/Chip/Chip';
import TextField from '../../../../components/TextField/TextField';
import ErrorBar from '../../../../components/ErrorBar';
import RadioField from '../../../../components/RadioField2/RadioField';
import './styles.scss';
import { Icon_Check, Icon_EmptyCheckbox } from '../../styles/assets/icons';
import { TexasHealthFacilities } from '../../../../components/sectionComponents/Facilities/selectAndType';
import { CheckLanguage } from '../../../../languages/languages';
import { GetLanguageText } from '../../../../languages/languages';
import Popover from "../../../../../formik/refactorOut/components/Popper/Popover";
import { popoverLocation } from "../../../../../config/Configuration";


const AuthorizationToRelease = () => {
    const [physicianListVisible, setPhysicianListVisibility] = useState(false);
    const [physiciansSelected, setPhysiciansSelected] = useState(false);
    const [allPhysiciansSelected, setAllPhysiciansSelected] = useState(false);
    const [discloseToOther] = useState('none');
    const [facilitySelect, setFacility] = useState("");
    const { formik, dbFormSpec, validationValues } = useContext(ConfigContext);
    const [checked, setChecked] = useState(false);
    const [selected, setSelected] = useState(false);
    const template = { ...validationValues.page.form.sections.authorizationToReleaseSection, styles: { ...validationValues.page.form.styles } }
    const orgId = dbFormSpec.facility.orgId;

    const otherPhysicians = [
        { input: '', id: 0, type: '' }
    ];

    const samplePhysicianList = [{ value: 'CBC Physicians', label: 'physicianLabel1' }];

    const renderFacilityRadiogroup = (dbFormSpec.release.facilitiesRadiogroup);
    const renderAdvancedFacilityList = (dbFormSpec.release.facilitiesAdvanced);
    const useFacilitiesSelectionList = (dbFormSpec.release.FacilitiesSelectionList);

    const languageID = CheckLanguage(dbFormSpec);

    if (useFacilitiesSelectionList === true) {
        const languageText = GetLanguageText(languageID);
        return (<FacilitiesSelectionList formik={formik} languageText={languageText} />);
    }

    if (orgId === '1007224') {
        return (
            <Facilities_7224 orgId={orgId} formik={formik} template={template} config={validationValues} />
        );
    }

    if (orgId === '1007168') {
        return (
            <Facilities_7168 orgId={orgId} formik={formik} template={template} config={validationValues} formColor={dbFormSpec.color} />
        );
    }
    if (orgId === '1007302') {
        return (
            <Facilities_7302 orgId={orgId} formik={formik} template={template} config={validationValues} formColor={dbFormSpec.color} />
        );
    }

    if (orgId === '1007227') {
        return (
            <Facilities_7227 orgId={orgId} formik={formik} template={template} config={validationValues} />
        );
    }

    if (orgId === '1007307') {
        return (
            <Facilities_NameAddressDoc orgId={orgId} formik={formik} template={template} config={validationValues} formColor={dbFormSpec.color} />
        );
    }



    if (languageID !== "default") {

        const languageText = GetLanguageText(languageID);

        return (
            validationValues.page.form.sections.authorizationToReleaseSection.active ?
                <div id='medicalFacilitiesRequested' className='form-section'>
                    <SectionHeader sectionTitle={`${languageText.facilitiesReleasingInfo.label}`} styles={{ color: dbFormSpec.color }} />

                    <div id='facility-disclosure-container'>
                        <div className='facility-selection' id='facilityOrPhysician'>
                            {formik.errors.facilityList && formik.touched.facilityOrPhysician && <ErrorBar message={formik.errors.facilityList} />}
                            {(!formik.errors.facilityOrPhysician && formik.values.inputDisclosePhysicians && formik.errors.inputPhysicianNames && formik.touched.inputPhysicianNames) && <ErrorBar message={formik.errors.inputPhysicianNames} />}
                            <label className='section-instruction subtitle1'> {`${languageText.facilitiesReleasingInfo.options.option1}`}</label>
                            {dbFormSpec.AuthorizationToReleaseCustomTextListTop ? <div id="CustomText"> {dbFormSpec.AuthorizationToReleaseCustomTextListTop.map((item, index) => {
                                return <div key={index + "AuthorizationToReleaseCustomTextListTop"} >{item}</div>
                            })} </div>
                                : <></>}

                            <div className='facilities-physicians'>

                                {
                                    renderAdvancedFacilityList ? <FacilityAdvancedList dbFormSpec={dbFormSpec} formik={formik} /> :
                                        renderFacilityRadiogroup ? <FacilityRadioList dbFormSpec={dbFormSpec} formik={formik} /> :

                                            <div id='ordinary-facilities' className='form-fields' style={{}}>
                                                {dbFormSpec.release.facilities.map((item, index) => {
                                                    return (
                                                        (!item.type) && (item.key !== 'otherFac') &&
                                                        <>
                                                            <div className='facility-item' key={index}><CheckField checkboxType={'facility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} /></div>
                                                        </>
                                                    )
                                                })
                                                }
                                                <div style={{ display: 'block', width: '100%', marginTop: 10 }}><TextField formik={formik} fieldId={'facilityOther'} cssField={'fname-field'} label={`${languageText.facilitiesReleasingInfo.options.option18}`} maxLength={500} /></div>
                                            </div>}
                                <div id="CustomText">{dbFormSpec.AuthorizationToReleaseCustomText ? dbFormSpec.AuthorizationToReleaseCustomText : ""} </div>
                                {dbFormSpec.AuthorizationToReleaseCustomTextListTop ? <div id="CustomText"> {dbFormSpec.AuthorizationToReleaseCustomTextListTop.map((item, index) => {
                                    return <div key={index + "AuthorizationToReleaseCustomTextListTop"} >{item}</div>
                                })} </div>
                                    : <></>}
                            </div>
                        </div>
                    </div>
                </div>
                :
                <></>
        );
    } else {
        return (
            validationValues.page.form.sections.authorizationToReleaseSection.active ?
                <div id='medicalFacilitiesRequested' className='form-section'>
                    <SectionHeader sectionTitle={'Facilities Releasing Information'} styles={{ color: dbFormSpec.color }} />
                    <div id='facility-disclosure-container'>
                        <div className='facility-selection' id='facilityOrPhysician'>
                            {formik.errors.facilityList && formik.touched.facilityList && <ErrorBar message={formik.errors.facilityList} />}

                            <label className='section-instruction subtitle1'> {"Select the parties from which you'd like to receive the requested medical information"}</label>

                            {dbFormSpec.AuthorizationToReleaseCustomTextListTop ? <div id="CustomText"> {dbFormSpec.AuthorizationToReleaseCustomTextListTop.map((item, index) => {
                                return <div key={index + "AuthorizationToReleaseCustomTextListTop"} >{item}</div>
                            })} </div>
                                : <></>}

                            <div className='facilities-physicians'>
                                {orgId == '1007451' ? <TexasHealthFacilities formik={formik} dbFormSpec={dbFormSpec} /> :
                                    renderAdvancedFacilityList ? <FacilityAdvancedList dbFormSpec={dbFormSpec} formik={formik} /> :
                                        renderFacilityRadiogroup ? <FacilityRadioList dbFormSpec={dbFormSpec} formik={formik} /> :

                                            <div id='ordinary-facilities' className='form-fields' style={{}}>
                                                {dbFormSpec.release.facilities.map((item, index) => {
                                                    return (
                                                        (!item.type) && (item.key !== 'otherFac') &&
                                                        <>
                                                            <div className='facility-item'><CheckField  key={index} checkboxType={'facility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} /></div>
                                                        </>
                                                    )
                                                })
                                                }
                                                <div style={{ display: 'block', width: '100%', marginTop: 10 }}><TextField formik={formik} fieldId={'facilityOther'} cssField={'fname-field'} label={'Other facilities or providers'} requiredVal={false} maxLength={500} /></div>
                                            </div>
                                }
                                <div id="CustomText">{dbFormSpec.AuthorizationToReleaseCustomText ? dbFormSpec.AuthorizationToReleaseCustomText : ""} </div>
                                {dbFormSpec.AuthorizationToReleaseCustomTextListBottom ? <div id="CustomText"> {dbFormSpec.AuthorizationToReleaseCustomTextListTop.map((item, index) => {
                                    return <div key={index + "AuthorizationToReleaseCustomTextListTop"} >{item}</div>
                                })} </div>
                                    : <></>}
                            </div>
                        </div>
                    </div>
                </div>
                :
                <></>
        );
    }
};


export default AuthorizationToRelease;

